var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarLeftVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 42,
    viewBox: "0 0 15 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56598 35.9915C7.8813 37.2954 7.84013 39.0452 7.74476 40.3201C7.67764 41.2162 8.57973 41.9999 9.73379 41.9999H14.4643V0H9.73379C8.57973 0 7.67764 0.7836 7.74476 1.6797C7.84013 2.95462 7.8813 4.70445 7.56598 6.00832C7.3305 6.98212 7.16214 7.53 6.71451 8.45828C5.93084 10.084 3.95762 10.5754 3.84769 12.3082C3.75927 13.7014 5.32816 15.6916 5.32816 15.6916C5.32816 15.6916 3.35514 15.9689 2.55748 16.6833C1.61171 17.5304 2.4759 18.5633 1.70505 19.5416C1.19957 20.1829 0 20.9416 0 20.9416C0 20.9416 1.20439 21.7949 1.70505 22.4874C2.38584 23.4293 1.70708 24.343 2.55748 25.1708C3.33759 25.93 5.32816 26.3082 5.32816 26.3082C5.32816 26.3082 3.75927 28.2984 3.84769 29.6915C3.95762 31.4244 5.93084 31.9159 6.71451 33.5416C7.16214 34.4698 7.3305 35.0177 7.56598 35.9915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLeftVector);
export default __webpack_public_path__ + "static/media/navbar_left_vector.681ce4e70283c1982cf1ad0a89500971.svg";
export { ForwardRef as ReactComponent };